import React from 'react';
import { Alert, AlertDescription } from '@components/ui/alert';
import { ConfirmationModal } from '../../components/confirmation-modal';
import { injectTSDI } from '../../core/tsdi';
import { Api } from '../../core/api';
import {
    TenantDto,
    TenantPageEntrySupportDto
} from '../../core/api/TenantClient';

type Props = {
    onSuccess: () => void;
    tenant?: TenantPageEntrySupportDto | TenantDto;
    openState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
};

export const TenantActivateModal = ({
    onSuccess,
    tenant,
    openState: [open, setOpen]
}: Props) => {
    const { tenantClient } = injectTSDI(Api);

    const handleActivate = async () => {
        if (tenant) {
            await tenantClient.admin.tenantAdminControllerActivateTenant(
                tenant.name
            );
            onSuccess();
        }
    };
    return (
        <ConfirmationModal
            open={open}
            submitHandler={handleActivate}
            onModalClose={() => void setOpen(false)}
            buttonText="Activate"
        >
            <p className="text-lg font-semibold">
                You are about to activate tenant <b>{tenant?.name}</b>
            </p>
            <Alert variant="warning">
                <AlertDescription>
                    Are you sure you want to activate this tenant?
                </AlertDescription>
            </Alert>
        </ConfirmationModal>
    );
};
